import { render, staticRenderFns } from "./CategoriesFormPage.vue?vue&type=template&id=95829f64&scoped=true&"
import script from "./CategoriesFormPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesFormPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFormPage.vue?vue&type=style&index=0&id=95829f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95829f64",
  null
  
)

export default component.exports